// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"_3IYrfFNT","divider":"_3d7hBDgK","errorSection":"_3d9k_IcV","loaderWrapper":"_2xl17NOQ"};